module.exports = __webpack_public_path__ + "static/media/28.cc58cce5.mp4";